// extracted by mini-css-extract-plugin
module.exports = {"contact-us-clinic-landing":"ContactUsLandingClinic_contact-us-clinic-landing__3bdet"};